export default __webpack_public_path__ + "static/media/bedroom1.41953689.jpg";